import { render } from "./LocalProfile.vue?vue&type=template&id=49110181&ts=true"
import script from "./LocalProfile.vue?vue&type=script&lang=ts"
export * from "./LocalProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__